export default {
      id: "Icon--comment-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--comment",
      toString: function () {
        return this.url;
      }
    }